import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 50rem 0;
  max-width: 1440rem;
  width: 100%;

  ${respondTo.smallLaptop`
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    padding: 20rem 15rem;
  `}
`;

export const Heading = styled.h2`
  font-size: 40rem;
  font-weight: 300;
  color: ${COLORS.BLACK};

  ${respondTo.smallTablet`
    font-size: 30rem;
  `}
`;

export const FirstRow = styled.div`
  margin-bottom: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${respondTo.bigPhone`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;

  ${respondTo.bigPhone`
    margin-bottom: 10rem;
  `}
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 30rem;

  ${respondTo.smallTablet`
    gap: 15rem;
  `}

  ${respondTo.bigPhone`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 10rem;
  `}
`;

export const InputWrapper = styled.div`
  width: 300rem;

  ${respondTo.bigPhone`
    width: 100%;
  `}
`;

export const AddLabel = styled.label`
  font-size: 18rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
  cursor: pointer;

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;

export const AddWrapper = styled.div`
  display: flex;
  gap: 2rem;
  cursor: pointer;
  &:hover {
    ${AddLabel} {
      text-decoration: underline;
    }
  }
`;

export const NoContentLabel = styled.label`
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;

export const NoContentLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20rem 0;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30rem;
`;

export const CompaniesWrapper = styled.div`
  display: grid;
  grid-gap: 30rem;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 300rem);

  ${respondTo.smallLaptop`
    grid-template-columns: repeat(
      auto-fill,
      30%
    );
  `}

  ${respondTo.smallTablet`
    gap: 15rem;
    grid-template-columns: repeat(
      auto-fill,
      48%
    );
  `}

  ${respondTo.smallPhone`
    grid-template-columns: repeat(
      auto-fill,
      100%
    );
  `}
`;
